import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const phrases = [
    "Restoring people with the Word of God.",
    "Reconciling people with the Word of God.",
    "Raising people with the Word of God."
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % phrases.length);
        setFade(true);
      }, 300); // Duration of fade out
    }, 3000); // Total duration for each phrase

    return () => clearInterval(interval);
  }, [phrases.length]);

  const redirectToEmail = () => {
    // Redirect to the church email using mailto: protocol
    const churchEmail = 'mailto:Info@tegm.com';

    // Check if we're on a mobile device to handle the mailto: link properly
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      // On mobile, the mailto: link will work directly if email app is available
      window.location.href = churchEmail;
    } else {
      // On desktop, the mailto: link will open the default email client
      window.location.href = churchEmail;
    }
  };

  return (
    <div className="coming-soon-container">
      <div className="content">
        <div className="welcome-text">
          <p className="welcome-to">welcome to</p>
          <h1 className="ecclesia-ministry">the ecclesia gospel ministries</h1>
        </div>
        <p className={`vision-statement ${fade ? 'fade-in' : 'fade-out'}`}>
          {phrases[currentIndex]}
        </p>
        <button className="contact-btn" onClick={redirectToEmail}>Contact Us</button>
      </div>
    </div>
  );
}

export default App;